export default "__VITE_ASSET__CzgWPzzN__"